import Tools from "src/utils/tools";

export const HOME_PAGE = "http://www.viphrm.com";

export const LOGIN_URL = "http://login.viphrm.com/";

export const TOKEN = Tools.getCookie("ms_member_token") || "";

export const CID = Tools.getCookie("ms_cid") || "";

export const LOCALHOST = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;

export const ONE_M = 1048576;

export const ERROR_MESSAGE = "系统维护中，请联系管理员。";



// WEBPACK FOOTER //
// ./src/common/constants.ts